import React from 'react';
import { Form, Container } from 'react-bootstrap';

const QuestionDescription = ({values, handleChange, errors}) => {
  return (
    <Container>
      <Form.Group className="mt-3">
        <Form.Control
          as="textarea"
          rows={3}
          name="description"
          placeholder="Descripción de la pregunta"
          onChange={handleChange}
          value={values.description}
          isInvalid={!!errors.description} />
        <Form.Control.Feedback type="invalid">
          {errors.description}
        </Form.Control.Feedback>
      </Form.Group>
    </Container>
  )
}

export default QuestionDescription